import React, { Component } from 'react';
import Moment from 'react-moment';
import Truncate from 'react-truncate';
import TextWithTooltip from '../text-with-tooltip';
import CheckBox from '../check-box/check-box';
import { Desktop, Mobile } from '../../app-responsive';

export const FormatTime = ({ children }) => <Moment format="h:mm a" parse="hh:mm">{children}</Moment>;

class HighlightsCheckBox extends Component {
  onCheckBoxStatusChanged = (checkBoxState) => {
    const { checkBoxChanged } = this.props;
    checkBoxChanged(checkBoxState);
  };

  render() {
    const {
      highlightsContent:
        { name, description, date, startTime, endTime },
      slideId,
      checked,
      desktopClasses,
    } = this.props;
    const highlightTooltipContent = () => (
      <React.Fragment>
        <p className="font-weight-bold">{name}</p>
        <p className="font-italic">{description}</p>
        <p className="font-weight-bold"><Moment format="dddd DD MMM YYYY" parse="DD-MM-YYYY">{date}</Moment></p>
        <p className="font-italic">
          <FormatTime>{startTime}</FormatTime> - <FormatTime>{endTime}</FormatTime>
        </p>
      </React.Fragment>
    );
    return (
      <div className={`trip-report-slide mb-3 ${desktopClasses}`}>
        <div className="trip-report-slide-wrapper d-flex flex-row align-items-center text-left justify-content-between w-100">
          <CheckBox
            id={slideId}
            checked={checked}
            callBackAction={this.onCheckBoxStatusChanged}
            iconType="tick"
          />
          <Desktop>
            <label htmlFor={slideId}>
              <Truncate
                lines={2}
                width={190}
                ellipsis=""
                className="text-truncate"
              >{name}</Truncate></label>
          </Desktop>
          <Mobile>
            <label htmlFor={slideId}>{name}</label>
          </Mobile>
          <TextWithTooltip
            text={<i className="td-icon icon-information" />}
            textClassName="help-icon-container h-100"
            id={`${slideId}-tooltip`}
            Content={highlightTooltipContent}
          />
        </div>
      </div>
    );
  }
}

export default HighlightsCheckBox;
